import { useState, useEffect } from 'react';
import { Link } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../../../api/context';
import Icon from '../../../../components/Icon';
import { Title } from '../../../../utils/title';
import toast from '../../../../utils/toast';
import Layout from '../Layout';
import styles from './Privacy.module.scss';

const Privacy = () => {

  const [ loading, setLoading ] = useState(true);
  const [ initial, setInitial ] = useState({
    transfer_disable: '',
  });

  const { token } = useAPIContext();

  useEffect(() => {

    api(token).v1.profile.query()
      .then(res => {
        if (res.status === 200) {
          setLoading(false);
          setInitial({
            transfer_disable:
              res.body.data.transfer_disable.value
              ? 'Y'
              : 'N',
          });
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token]);

  return (
    <>
      <Title value='Privacy - Profile' />
      <Layout>
        <div className={styles.root}>
          <div className={styles.content}>
            <div className={styles.header}>
              <Link
                to='/profile'
                aria-label='go back'>

                <Icon name={'arrow_back'} />

              </Link>

              <h1>Privacy Settings</h1>
            </div>

            <Formik
              enableReinitialize={true}
              initialValues={initial}
              validationSchema={yup.object({
                transfer_disable: yup.string()
                  .required('Required'),
              })}
              onSubmit={(values, actions) => {

                if (loading) {
                  return;
                }

                setLoading(true);

                api(token).v1.profile
                  .update(values)
                  .then(res => {
                    setLoading(false);

                    if (res.status === 200) {
                      toast.show(toast.KIND.SUCCESS, 'Privacy settings saved.');
                    }

                    if (res.status === 400) {
                      toast.show(toast.KIND.ERROR, res.body);
                    }
                  })
                  .catch(err => {
                    setLoading(false);
                    toast.show(toast.KIND.WARNING, err);
                  });

              }} >

              <Form>
                <div>
                  <label htmlFor='transfer_disable'>
                    <b>Disable</b> sharing my information with 3rd-party partners?
                  </label>
                  <Field
                    id='transfer_disable'
                    as='select'
                    aria-label='disable transfer'
                    name='transfer_disable'
                    disabled={loading} >

                    <option value=''></option>
                    <option value='Y'>Yes, disable sharing</option>
                    <option value='N'>No, enable sharing</option>
                  </Field>
                  <ErrorMessage
                    name='transfer_disable'
                    component='div'
                  />
                </div>

                <button
                  type='submit'
                  disabled={loading}>

                  Save

                </button>
              </Form>

            </Formik>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Privacy;